<!-- <nav>
  <a [routerLink]="['/']" [routerLinkActive]="['router-link-active']" [routerLinkActiveOptions]="{exact:true}">HOME</a>
  <a [routerLink]="['/about']" [routerLinkActive]="['router-link-active']" [routerLinkActiveOptions]="{exact:true}">ABOUT</a>
  <a [routerLink]="['/docs']" [routerLinkActive]="['router-link-active']" [routerLinkActiveOptions]="{exact:true}">Documents</a>
</nav> -->

<!-- Second navbar -->
<div  *ngIf="showNavbar == true" class="navbar navbar-default navbar-fixed-top" id="navbar-second" style="z-index: 999">
    <!--<ul class="nav navbar-nav no-border visible-xs-block">
        <li><a class="text-center collapsed" data-toggle="collapse" [attr.data-target]="'#' + selectedNavbarItem"><i class="icon-menu7"></i></a></li>
    </ul>-->
    <div *ngIf="navigationContent=='docs'" [ngClass]="{ 'disabled': page != 'JOBS' }" class="navbar-collapse collapse" id="navbar-second-toggle-docs">
        <ul class="nav navbar-nav">
          <li>
            <button type="button" (click)="openNewJobDialog()" class="btn btn-primary btn-sm legitRipple newButto" data-toggle="modal" [attr.data-target]="isPlanQuotaSuitToUpload ? '#newJob' : null"><i class="icon-plus2 position-left"></i>{{'New' | translate}}</button>
            <div class="dropdown">
              <button class="btn btn-link dropdown-toggle" type="button" data-toggle="dropdown" style="padding-left: 1px"><span class="caret"></span></button>
              <ul class="dropdown-menu">
                <li><a class="dropdown-item" [attr.href]="null" (click)="newJobFromTemplate()" data-toggle="modal" data-target="#templateJobs" translate>New Document From Template</a></li>
                <li *ngIf="canCreatePublicLink"><a class="dropdown-item" [attr.href]="null" (click)="newPublicLinkFromTemplate()" data-toggle="modal" data-target="#templateJobs" translate>New Public Link From Template</a></li>
              </ul>
            </div>
          </li>
          <li>
            <div class="dropdown">
              <button class="btn btn-default dropdown-toggle"  type="button" data-toggle="dropdown" [ngClass]="{ 'disabled': !isBulkOperationActive }" [attr.disabled]="isBulkOperationActive ? null : true" [innerHTML]="innerHtmlBulkOperations"translate>Bulk Operations<span class="caret"></span></button>
              <ul class="dropdown-menu">
                <li><a class="dropdown-item" [attr.href]="null" (click)="bulkOperation('Archive'); bulkOperationTitle('Archive')" translate>Archive</a></li>
                <li><a class="dropdown-item" [attr.href]="null" (click)="bulkOperation('Move to Inbox'); bulkOperationTitle('Move to Inbox')" translate>Move to Inbox</a></li>
                <li><a class="dropdown-item" [attr.href]="null" (click)="bulkOperation('Delete'); bulkOperationTitle('Delete')" translate>Delete</a></li>
                <li><a class="dropdown-item" [attr.href]="null" (click)="bulkOperation('Download'); bulkOperationTitle('Download')" translate>Download</a></li>
                <li><a class="dropdown-item" [attr.href]="null" (click)="bulkOperation('ApplyTemplateAndSend'); bulkOperationTitle('Apply Template and Send')" data-toggle="modal" [attr.data-target]="this.authorization.userAccount.subscription.plan.bulkSign == 'Y' ? '#templateJobs' : null" translate>Apply Template and Send</a></li>
                <li><a class="dropdown-item" [attr.href]="null" (click)="bulkOperation('BulkSign'); bulkOperationTitle('Bulk Sign')" translate>Bulk Sign</a></li>
              </ul>
            </div>
          </li>
        </ul>

        <ul class="nav navbar-nav navbar-right">
            <li>
               <div class="has-feedback has-feedback-right searchButton">
                    <input id="searchFilter" class="form-control" #input (keyup.enter)="FilterWithSearch(input.value)" (focusout)="inputFocusOut(input.value)" [placeholder]="'search' | translate" type="search">
                    <div class="form-control-feedback">
                      <i class="icon-search4 text-size-base text-muted" style="pointer-events: auto; text-decoration: none;cursor: pointer;" (click)="FilterWithSearch(input.value); isFocus = true;"></i>
                    </div>
                </div>
            </li>
            <li>
                <div class="dropdown">
                    <button class="btn btn-default dropdown-toggle"  type="button" data-toggle="dropdown" [ngClass]="{ 'disabled': isSmartStatusSelected || selectedItem=='Templates' }" [attr.disabled]="isSmartStatusSelected || selectedItem=='Templates' ? true : null" [innerHTML]="innerHtmlStatus" translate>Select Status<span class="caret"></span></button>
                    <ul class="dropdown-menu">
                        <li><a class="dropdown-item" [attr.href]="null" (click)="FilterWithStatus('ALL'); statusTitle('All')" translate>All</a></li>
                       <!-- <li><a class="dropdown-item" [attr.href]="null" (click)="FilterWithStatus('NONE'); statusTitle('None')" translate>None</a></li>-->
                        <li><a class="dropdown-item label-default" [attr.href]="null" (click)="FilterWithStatus('DRAFT'); statusTitle('Draft')" translate>Draft</a></li>
                        <li><a class="dropdown-item label-warning" [attr.href]="null" (click)="FilterWithStatus('IN_PROGRESS'); statusTitle('In Progress')" translate>In Progress</a></li>
                        <li><a class="dropdown-item label-danger" [attr.href]="null" (click)="FilterWithStatus('REJECTED'); statusTitle('Rejected')" translate>Rejected</a></li>
                        <li><a class="dropdown-item label-success" [attr.href]="null" (click)="FilterWithStatus('COMPLETED'); statusTitle('Completed')" translate>Completed</a></li>
                        <!--<li><a class="dropdown-item" href="#">Cancelled</a></li>-->
                    </ul>
                </div>
            </li>
            <li>
                <div class="dropdown">
                    <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" [ngClass]="{ 'disabled': selectedItem=='Templates' }" [attr.disabled]="selectedItem=='Templates' ? true : null" [innerHTML]="innerHtmlSorting" translate>Select Sorting<span class="caret"></span></button>
                    <ul class="dropdown-menu">
                        <li><a [attr.href]="null" (click)="OrderBy('created'); sortingTitle('Creation Date')" translate>Creation Date</a></li>
                        <li><a [attr.href]="null" (click)="OrderBy('updated'); sortingTitle('Modification Date')" translate>Modification Date</a></li>
                        <li><a [attr.href]="null" (click)="OrderBy('name'); sortingTitle('Name')" translate>Name</a></li>
                    </ul>
                </div>
            </li>
          <li>
            <label><strong>{{listInterval}}</strong></label>
            <button (click)="PreviousRecords()" type="button" [ngClass]="{ 'disabled': !isPreButtonActive }"  [attr.disabled]="isPreButtonActive ? null : true" class="btn btn-default"><i class="icon-circle-left2"></i></button>
            <button (click)="NextRecords()" type="button" [ngClass]="{ 'disabled': !isNextButtonActive }" [attr.disabled]="isNextButtonActive ? null : true" class="btn btn-default"><i class="icon-circle-right2"></i></button>
          </li>
        </ul>
    </div>

    <div *ngIf="navigationContent=='doc'" [ngClass]="{ 'disabled': page != 'DETAILS' }" class="navbar-collapse collapse" id="navbar-second-toggle-doc">
        <ul class="nav navbar-nav">
            <li class="dropdown">
                <button class="btn btn-default dropdown-toggle text-center" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                  <span class="icon-folder6 icon"></span><span translate>&nbsp;File Operations</span>
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">
                  <li><a class="dropdown-item" [attr.href]="null" (click)="DeleteJob()" translate>Delete Job</a></li>
                  <li><a class="dropdown-item" [attr.href]="null" data-toggle="modal" data-target="#jobDetailsChangeNameModal" translate>Change Name</a></li>
                  <li><a class="dropdown-item" [attr.href]="null" (click)="setJobLocation(jobJocation)" [innerHTML]="jobLocationAction"></a></li>
                  <li *ngIf="currentToolbar?.value=='IN_PROGRESS' || currentToolbar?.value=='COMPLETED'"><a class="dropdown-item" [attr.href]="null" (click)="DownloadOriginal()" translate>Download Original</a></li>
                  <li *ngIf="currentToolbar?.value=='COMPLETED'"><a class="dropdown-item" [attr.href]="null" (click)="DownloadSigned()" translate>Download Signed Document</a></li>
                  <!--
                    The owner's Signing Log, beside the signed document rather than in
                    its own control: it is a download of the same job and belongs where the owner
                    already looks. Gated on signingLogAvailable and not on value=='COMPLETED',
                    because COMPLETED is necessary but not sufficient — the server also requires
                    PAdES-LTA, and only it can say. The guest page has its own copy of this button
                    in the view section; the two cannot share one, as each navbar section renders
                    only for its own page.
                  -->
                  <li *ngIf="currentToolbar?.signingLogAvailable"><a class="dropdown-item" [attr.href]="null" data-testid="download-signing-log-owner" (click)="DownloadSigningLog()" translate>Signing Log</a></li>
                  <li *ngIf="isSuitToCreateTemplate"><a class="dropdown-item" [attr.href]="null" (click)="createTemplate()" translate>Create Template</a></li>
                  <li *ngIf="currentToolbar?.value=='NONE'"><a class="dropdown-item" [attr.href]="null" (click)="applyTemplate()" data-toggle="modal" data-target="#jobTemplate" translate>Apply Template</a></li>
                </ul>
            </li>
            <li>
              <button type="button" *ngIf="isSuitToCombine" (click)="navigateToCombine()" class="btn btn-primary"><i class="icon-stack-plus"></i>&nbsp;{{translate.instant("Combine")}}</button>
            </li>
            <li>
              <button type="button" *ngIf="selfSign != ''" (click)="navigateToSign()" [attr.disabled]="isAccountSuspended ? true : null" class="btn btn-primary" [innerHTML]="selfSign"></button>
            </li>
            <li>
              <button type="button" *ngIf="requestSign != ''" (click)="navigateToRequest()" [attr.disabled]="isAccountSuspended ? true : null" class="btn btn-primary"><i class="icon-blog"></i>&nbsp;{{translate.instant(requestSign)}}</button>
            </li>
            <li>
              <button (click)="PDFIncrementZoom(-0.2)" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-zoomout3"></i></button>
            </li>
            <li>
              <button (click)="PDFIncrementZoom(0.2)" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-zoomin3"></i></button>
              <!--      <button (click)="PDFRotate(-90)" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-rotate-ccw"></i></button>-->
              <!--      <button (click)="PDFRotate(90)" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-rotate-cw"></i></button>-->
            </li>
        </ul>
        <ul class="nav navbar-nav navbar-right">
            <li>
              <button type="button" (click)="openJobDetailsTagModal()" class="btn btn-primary btn-icon btn-rounded" data-toggle="modal" data-target="#jobDetailsTagModal"><i class="icon-price-tag3"></i></button>
            </li>
            <li>
              <button type="button" (click)="openJobDetailsActivityHistoryModal()" class="btn btn-primary btn-icon btn-rounded" data-toggle="modal" data-target="#jobDetailsActivityHistoryModal"><i class="icon-history"></i></button>
            </li>
            <li>
              <button type="button" (click)="openJobDetailsInfoModal()" class="btn btn-primary btn-icon btn-rounded" data-toggle="modal" data-target="#jobDetailsInfoModal"><i class="icon-info3"></i></button>
            </li>
            <li *ngIf="currentToolbar?.value=='IN_PROGRESS' || currentToolbar?.value=='COMPLETED'">
              <button type="button" (click)="OpenAttachments()" class="btn btn-primary btn-icon btn-rounded" title="{{ 'Attachments' | translate }}"><i class="icon-attachment"></i></button>
            </li>
            <li *ngIf="currentToolbar.value=='COMPLETED'">
              <button type="button" (click)="openValidationModal()" class="btn btn-success btn-icon btn-rounded" data-toggle="modal" data-target="#validationModal" title="{{ 'VALIDATE_DOCUMENT' | translate }}"><i class="icon-checkmark3"></i></button>
            </li>
            <li *ngIf="currentToolbar.value=='COMPLETED'" class="dropdown">
              <button class="btn btn-primary btn-icon btn-rounded dropdown-toggle" type="button" id="dropdownMenuShare" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"><span class="icon-share3"></span></button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuShare">
                <li><a class="dropdown-item" [attr.href]="null" (click)="shareSignedDocument()" data-toggle="modal" data-target="#shareSignedDocument" translate>Send As Attachment</a></li>
                <!--<li><a class="dropdown-item" [attr.href]="null" data-toggle="modal" data-target="#sharewithUser" translate>Share with User</a></li>
                <li class="divider"></li>-->
                <li><a class="dropdown-item" [attr.href]="null" (click)="getPublicLink()" data-toggle="modal" data-target="#publicLink" translate>Get Public Link</a></li>
                <li><a class="dropdown-item" [attr.href]="null" (click)="stopSharingPublic()" [ngClass]="{ 'disabled': currentToolbar.sharePublicLink == '' }" translate>Stop Sharing Public</a></li>
                <li *ngIf="currentToolbar?.value=='COMPLETED'"><a class="dropdown-item" [attr.href]="null" (click)="openSftpMenu()" data-toggle="modal" data-target="#sftpList">{{translate.instant("Send with SFTP")}}</a></li>
                <li class="divider"></li>
              <!--<li><a class="dropdown-item" [attr.href]="null" data-toggle="modal" data-target="#managePermission" translate>Manage Permission</a></li>-->
            </ul>
          </li>
        </ul>
    </div>
    <div *ngIf="navigationContent=='sign'" [ngClass]="{ 'disabled': page != 'SIGN' || isRequestCodeUsed || currentToolbar?.value == 'REJECTED'}" class="navbar-collapse collapse" id="navbar-second-toggle-sign">
      <ul class="nav navbar-nav">
        <li>
          <button (click)="PDFIncrementZoom(-0.2)" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-zoomout3"></i></button>
          <button (click)="PDFIncrementZoom(0.2)" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-zoomin3"></i></button>
<!--          <button (click)="PDFRotate(-90)" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-rotate-ccw"></i></button>-->
<!--          <button (click)="PDFRotate(90)" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-rotate-cw"></i></button>-->
        </li>
      </ul>
      <ul class="nav navbar-nav navbar-right">
        <li *ngIf="currentToolbar?.attachmentCount > 0">
          <button (click)="OpenAttachments()" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-attachment"></i> <span translate>Attachments</span>&nbsp;<span class="label label-default">{{currentToolbar?.attachmentCount}}</span></button>
        </li>
        <li>
          <button *ngIf="currentToolbar?.jobType != 'SELF'" (click)="RejectSign()" type="button"
                  class="btn btn-danger btn-space" translate>Reject
          </button>
          <button (click)="ApproveSign()" type="button" class="btn btn-success btn-space" translate>Approve</button>
        </li>
      </ul>
    </div>

    <div *ngIf="navigationContent=='signcades'" [ngClass]="{ 'disabled': page != 'SIGNCADES' || isRequestCodeUsed || currentToolbar?.value == 'REJECTED'}" class="navbar-collapse collapse" id="navbar-second-toggle-sign">

      <ul class="nav navbar-nav navbar-right">
        <li>
          <button *ngIf="currentToolbar?.jobType != 'SELF'" (click)="RejectSign()" type="button"
                  class="btn btn-danger btn-space" translate>Reject
          </button>
          <button (click)="ApproveSign()" type="button" class="btn btn-success btn-space" translate>Approve</button>
        </li>
      </ul>
    </div>

    <div *ngIf="navigationContent=='multisign'" [ngClass]="{ 'disabled': page != 'MULTI_SIGN'}" class="navbar-collapse collapse" id="navbar-second-toggle-multisign">
      <ul class="nav navbar-nav navbar-right">
        <li>
          <!--<button *ngIf="currentToolbar?.jobType != 'SELF'" (click)="RejectSign()" type="button" class="btn btn-danger" translate>Reject</button>-->
          <button (click)="ApproveSign()" type="button" class="btn btn-success" translate>Approve</button>
        </li>
      </ul>
    </div>
    <div *ngIf="navigationContent=='combine'" [ngClass]="{ 'disabled': page != 'COMBINE' }" class="navbar" id="navbar-second-toggle-combine">
      <div class="combine-pdf-actions">
        <button (click)="CancelCombine()" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-cross2"></i> <span translate>Cancel</span></button>
        <button (click)="CombineAndSave()" type="button" class="btn btn-sm border-default btn-primary btn-icon pull-right"><span translate>Combine & Save</span></button>
      </div>
    </div>
    <div *ngIf="navigationContent=='prepare'" [ngClass]="{ 'disabled': page != 'PREPARE' }" class="navbar" id="navbar-second-toggle-prepare">
      <ul class="nav navbar-nav">
        <li>
          <button (click)="CloseRequest()" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-cross2"></i> <span translate>Close</span></button>
        </li>
        <li>
          <button (click)="EditRecipients()" type="button" class="btn btn-sm border-default btn-flat btn-icon" data-toggle="modal" data-target="#requestModal"><i class="icon-cog3"></i> <span translate>&nbsp;Edit Recipients</span></button>
        </li>
        <li>
          <button (click)="SharedSigning()" type="button" class="btn btn-sm border-default btn-flat btn-icon" data-toggle="modal" [attr.data-target]="this.authorization.userAccount.subscription.plan.sharedSigning == 'Y' ? '#sharedSigningModal' : null"><i class="icon-users"></i> <span translate>Shared Signing</span></button>
        </li>
        <li>
          <button (click)="OpenAttachments()" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-attachment"></i> <span translate>Attachments</span><span *ngIf="currentToolbar?.attachmentCount > 0">&nbsp;<span class="label label-default">{{currentToolbar.attachmentCount}}</span></span></button>
        </li>
        <li>
          <button (click)="PDFIncrementZoom(-0.2)" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-zoomout3"></i></button>
        </li>
        <li>
          <button (click)="PDFIncrementZoom(0.2)" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-zoomin3"></i></button>
        </li>
      </ul>
      <ul class="nav navbar-nav navbar-right">
        <li>
          <button (click)="FinishSendRequest()" type="button" class="btn btn-sm border-default btn-primary btn-icon"><i class="icon-mail5"></i> <span translate>&nbsp;Finish & Send Request</span></button>
        </li>
      </ul>
     <!-- <div class="row">
        <div class="col-sm-4 col-xs-6 text-left">
          <button (click)="CloseRequest()" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-cross2"></i> <span translate>Close</span></button>
          <button (click)="EditRecipients()" type="button" class="btn btn-sm border-default btn-flat btn-icon" data-toggle="modal" data-target="#requestModal"><i class="icon-cog3"></i> <span translate>Edit Recipients</span></button>
        </div>

        <div class="col-sm-4 col-xs-8">
          <button (click)="PDFIncrementZoom(-0.2)" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-zoomout3"></i></button>
          <button (click)="PDFIncrementZoom(0.2)" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-zoomin3"></i></button>
        </div>

        <div class="col-sm-4 col-xs-8">
          <button (click)="FinishSendRequest()" type="button" class="btn btn-sm border-default btn-primary btn-icon pull-right"><i class="icon-mail5"></i> <span translate>Finish & Send Request</span></button>
        </div>
      </div>-->
    </div>
    <div *ngIf="navigationContent=='template'" [ngClass]="{ 'disabled': page != 'TEMPLATE_PREPARE' }" class="navbar" id="navbar-second-toggle-template">
      <!-- Template Mode Indicator -->
      <ul class="nav navbar-nav">
        <li>
          <button (click)="CloseRequest()" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-cross2"></i> <span translate>Close</span></button>
        </li>
        <li>
          <button (click)="EditRecipients()" type="button" class="btn btn-sm border-default btn-flat btn-icon" data-toggle="modal" data-target="#requestModal"><i class="icon-cog3"></i> <span translate>&nbsp;Edit Recipients</span></button>
        </li>
        <li>
          <button (click)="SharedSigning()" type="button" class="btn btn-sm border-default btn-flat btn-icon" data-toggle="modal" [attr.data-target]="this.authorization.userAccount.subscription.plan.sharedSigning == 'Y' ? '#sharedSigningModal' : null"><i class="icon-users"></i> <span translate>Shared Signing</span></button>
        </li>
        <li>
          <button (click)="PDFIncrementZoom(-0.2)" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-zoomout3"></i></button>
        </li>
        <li>
          <button (click)="PDFIncrementZoom(0.2)" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-zoomin3"></i></button>
        </li>
      </ul>
      <ul class="nav navbar-nav navbar-right">
        <!-- NO Finish & Send button for templates -->
      </ul>
    </div>
  <div *ngIf="navigationContent=='prepare-self'" [ngClass]="{ 'disabled': page != 'PREPARE_SELF' }" class="navbar" id="navbar-second-toggle-prepare-self">
    <ul class="nav navbar-nav">
      <li>
        <button (click)="CloseRequest()" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-cross2"></i> <span translate>Close</span></button>
      </li>
      <!--<li>
        <button (click)="EditRecipients()" type="button" class="btn btn-sm border-default btn-flat btn-icon" data-toggle="modal" data-target="#requestModal"><i class="icon-cog3"></i> <span translate>Edit Recipients</span></button>
      </li>-->
      <li>
        <button (click)="PDFIncrementZoom(-0.2)" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-zoomout3"></i></button>
      </li>
      <li>
        <button (click)="PDFIncrementZoom(0.2)" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-zoomin3"></i></button>
      </li>
    </ul>
    <ul class="nav navbar-nav navbar-right">
      <li>
        <button (click)="FinishSelfSign()" type="button" class="btn btn-sm border-default btn-primary btn-icon"><span translate>Finish & Continue Signing</span></button>
      </li>
    </ul>
  </div>
  <div *ngIf="navigationContent=='template-self'" [ngClass]="{ 'disabled': page != 'TEMPLATE_PREPARE_SELF' }" class="navbar" id="navbar-second-toggle-template-self">

    <ul class="nav navbar-nav">
      <li>
        <button (click)="CloseRequest()" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-cross2"></i> <span translate>Close</span></button>
      </li>
      <!--<li>
        <button (click)="EditRecipients()" type="button" class="btn btn-sm border-default btn-flat btn-icon" data-toggle="modal" data-target="#requestModal"><i class="icon-cog3"></i> <span translate>Edit Recipients</span></button>
      </li>-->
      <li>
        <button (click)="PDFIncrementZoom(-0.2)" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-zoomout3"></i></button>
      </li>
      <li>
        <button (click)="PDFIncrementZoom(0.2)" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-zoomin3"></i></button>
      </li>
    </ul>
    <ul class="nav navbar-nav navbar-right">
      <!-- NO Finish button for templates -->
    </ul>
  </div>

  <div *ngIf="navigationContent=='form-designer'" [ngClass]="{ 'disabled': page != 'DESIGN' }" class="navbar" id="navbar-second-toggle-prepare-self">
    <ul class="nav navbar-nav">
      <li>
        <button (click)="CloseRequest()" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-cross2"></i> <span translate>Close</span></button>
      </li>
      <!--<li>
        <button (click)="EditRecipients()" type="button" class="btn btn-sm border-default btn-flat btn-icon" data-toggle="modal" data-target="#requestModal"><i class="icon-cog3"></i> <span translate>Edit Recipients</span></button>
      </li>-->
      <li>
        <button (click)="PDFIncrementZoom(-0.2)" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-zoomout3"></i></button>
      </li>
      <li>
        <button (click)="PDFIncrementZoom(0.2)" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-zoomin3"></i></button>
      </li>
    </ul>
    <ul class="nav navbar-nav navbar-right">
      <li>
        <button (click)="FinishSelfSign()" type="button" class="btn btn-sm border-default btn-primary btn-icon"><span translate>Finish & Continue Signing</span></button>
      </li>
    </ul>
  </div>
  <div *ngIf="navigationContent=='view'" [ngClass]="{ 'disabled': page != 'VIEW' }" class="navbar-collapse collapse" id="navbar-second-toggle-view">
      <ul class="nav navbar-nav">
        <li *ngIf="currentToolbar?.isDownloadAllowed == 'true'" class="dropdown">
          <button class="btn btn-default dropdown-toggle text-center" type="button" id="dropdownMenuView" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
            <span class="icon-folder6 icon"></span><span translate>&nbsp;File Operations</span>
          </button>
          <ul class="dropdown-menu" aria-labelledby="dropdownMenuView">
            <li><a class="dropdown-item" [attr.href]="null" (click)="DownloadDocumentWithLink()" translate>Download Document</a></li>
          </ul>
        </li>
        <!--
          Signing Log. A sibling of the File Operations dropdown, never an item inside
          it: that dropdown is gated on isDownloadAllowed (the document-download permission),
          and the log is a separate artifact with its own server-side authorisation.
        -->
        <li *ngIf="currentToolbar?.signingLogAvailable">
          <button (click)="DownloadSigningLog()" type="button"
                  class="btn btn-sm border-default btn-flat btn-icon"
                  data-testid="download-signing-log"
                  title="{{ 'Signing Log' | translate }}">
            <i class="icon-file-text2"></i>&nbsp;<span translate>Signing Log</span>
          </button>
        </li>
        <li><button (click)="PDFIncrementZoom(-0.2)" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-zoomout3"></i></button></li>
        <li><button (click)="PDFIncrementZoom(0.2)" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-zoomin3"></i></button></li>
        <li><button (click)="PDFRotate(-90)" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-rotate-ccw"></i></button></li>
        <li><button (click)="PDFRotate(90)" type="button" class="btn btn-sm border-default btn-flat btn-icon"><i class="icon-rotate-cw"></i></button></li>
      </ul>
      <ul class="nav navbar-nav navbar-right">
        <li>
          <button type="button" (click)="openJobDetailsInfoModal()" class="btn btn-primary btn-icon btn-rounded" data-toggle="modal" data-target="#jobDetailsInfoModal"><i class="icon-info3"></i></button>
        </li>
      </ul>
    </div>

</div>
